export function compressImg(imgScr) {
  return new Promise(function(resolve, reject) {
    const img = new Image()

    img.onload = () => {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const resizedDimensions = getResizedDimensions(img, 1500)

      canvas.width = resizedDimensions.width
      canvas.height = resizedDimensions.height
      ctx.drawImage(img, 0, 0, resizedDimensions.width, resizedDimensions.height)
      resolve(ctx.canvas.toDataURL('image/jpeg', 0.7))
    }
    img.src = imgScr
  })
}

export function getResizedDimensions(img, maxSize) {
  if (img.height < maxSize && img.width < maxSize) {
    return {
      width: img.width,
      height: img.height
    }
  }

  var max = Math.max(img.height, img.width)
  if(img.height === max) {
    var reducedHeight = maxSize
    var reducedWidth = Math.round(img.width / img.height * maxSize)
    return {
      width: reducedWidth,
      height: reducedHeight
    }
  } else {
    var reducedHeight =  Math.round(img.height / img.width * maxSize)
    var reducedWidth = maxSize
    return {
      width: reducedWidth,
      height: reducedHeight
    }
  }
}

export default {
  compressImg, computeResize: getResizedDimensions
}
